<template>
  <div class="add-pay-box">
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="1200px"
        :before-close="handleClose"
        :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="90px">
        <el-form-item label="设备类型:" prop="devType">
          <el-select  placeholder="选择设备类型"
                     v-model.number="params.devType" size="small"
                     style="width:100%">
            <el-option :value="0" label="全部"></el-option>
            <el-option :value="1" label="安卓"></el-option>
            <el-option :value="2" label="IOS"></el-option>
            <el-option :value="3" label="通用"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="域名类型:" prop="type">
          <el-select
              v-model="params.type"
              style="width:100%"
              :popper-append-to-body="false"
              :disabled="type === 'edit'"
              @change="handleChangeDomain"
              size="medium"
          >
            <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序号:" prop="sorted">
            <el-input placeholder="请输入排序号"  style="width:100%" v-model.number="params.sorted"></el-input>
        </el-form-item>
        <el-form-item label="激活状态:" prop="isActive">
          <el-switch v-model="params.isActive" size="small"></el-switch>
        </el-form-item>
        <template v-if="params.type == 'PLAYCONFIG'">
          <el-form-item label="配置:" prop="domain">
            <div class="xiangqin" v-for="(item, i) in params.domain" :key="i">
              <div
                  class="xiangqin_left"

              >
                <el-input
                    size="small"
                    v-model="item.title"
                    placeholder="请输入标题"
                    style="width: 150px;text-align:center"
                ></el-input>
              </div>
              <div class="xiangqin_left">
                <el-input size="small" placeholder="请输入免费观影时长" style="width: 300px"
                          v-model="item.url"></el-input>
              </div>
              <div class="xiangqin_left">
                <el-input size="small"
                          placeholder="请输入观影次数"
                          style="width: 150px;text-align:center"
                          v-model.number="item.weight"></el-input>
              </div>
              <div class="xiangqin_right">
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    size="small"
                    @click="deleteItem(i)"
                ></el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" size="small" @click="addDomain()"
            >新增配置
            </el-button
            >
          </el-form-item>
        </template>
        <template v-else-if="params.type == 'VIPCARD'">
          <el-form-item label="配置:" prop="domain">
            <div class="xiangqin" v-for="(item, i) in params.domain" :key="i">
              <div
                  class="xiangqin_left"

              >
                <el-input
                    size="small"
                    v-model="item.title"
                    placeholder="请输入标题"
                    style="width: 150px;text-align:center"
                ></el-input>
              </div>
              <div class="xiangqin_left">
                <el-input size="small" placeholder="随意输入可以保持和标题一致" style="width: 300px"
                          v-model="item.url"></el-input>
              </div>
              <div class="xiangqin_left">
                <el-input size="small"
                          placeholder="0横版 1竖版"
                          style="width: 150px;text-align:center"
                          v-model.number="item.weight"></el-input>
                {{ item.weight == 0 ? "横版" : "竖版" }}
              </div>
              <div class="xiangqin_left">
                <el-input size="small"
                          placeholder="备用字段"
                          style="width: 150px;text-align:center"
                          v-model="item.desc"></el-input>
              </div>
              <div class="xiangqin_right">
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    size="small"
                    @click="deleteItem(i)"
                ></el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" size="small" @click="addDomain()"
            >新增配置
            </el-button
            >
          </el-form-item>
        </template>
        <template v-else-if="params.type == 'MODULESELECTINDEX'">
          <el-form-item label="配置:" prop="domain">
            <div class="xiangqin" v-for="(item, i) in params.domain" :key="i">
              <div
                  class="xiangqin_left"

              >
                <el-input
                    size="small"
                    v-model="item.title"
                    placeholder="请输入标题"
                    style="width: 150px;text-align:center"
                ></el-input>
              </div>
              <div class="xiangqin_left">
                <el-input size="small" placeholder="随意输入可以保持和标题一致" style="width: 300px"
                          v-model="item.url"></el-input>
              </div>
              <div class="xiangqin_left">
                <el-input size="small"
                          placeholder="选中子模块的位置（从0开始）"
                          style="width: 150px;text-align:center"
                          v-model.number="item.weight"></el-input>
              </div>
              <div class="xiangqin_left">
                备用字段：
                <el-input size="small"
                          placeholder="备用字段"
                          style="width: 150px;text-align:center"
                          v-model="item.desc"></el-input>
              </div>
              <div class="xiangqin_right">
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    size="small"
                    @click="deleteItem(i)"
                ></el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" size="small" @click="addDomain()"
            >新增配置
            </el-button
            >
          </el-form-item>
        </template>
        <template v-else-if="params.type == 'NAVOPEN'">
          <el-form-item label="配置:" prop="domain">
            <div class="xiangqin" v-for="(item, i) in params.domain" :key="i">
              <div
                  class="xiangqin_left"

              >
                <el-input
                    size="small"
                    v-model="item.title"
                    placeholder="请输入标题"
                    style="width: 150px;text-align:center"
                ></el-input>
              </div>
              <div class="xiangqin_left">
                <el-input size="small" placeholder="随意输入可以保持和标题一致" style="width: 300px"
                          v-model="item.url"></el-input>
              </div>
              <div class="xiangqin_left">
                <el-input size="small"
                          placeholder="金刚区开关 0关闭 1打开"
                          style="width: 180px;text-align:center"
                          v-model.number="item.weight"></el-input>
              </div>
              <div class="xiangqin_left">
                备用字段：
                <el-input size="small"
                          placeholder="备用字段"
                          style="width: 150px;text-align:center"
                          v-model="item.desc"></el-input>
              </div>
              <div class="xiangqin_right">
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    size="small"
                    @click="deleteItem(i)"
                ></el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" size="small" @click="addDomain()"
            >新增配置
            </el-button
            >
          </el-form-item>
        </template>
        <template v-else-if="params.type == 'ANDROIDVERSION' || params.type == 'IOSVERSION'">
          <el-form-item label="下载地址:" prop="domain">
            <div class="xiangqin" v-for="(item, i) in params.domain" :key="i">
              <div
                  class="xiangqin_left"

              >
                <el-input
                    size="small"
                    v-model="item.title"
                    placeholder="apk版本号"
                    style="width: 150px;text-align:center"
                ></el-input>
              </div>
              <div class="xiangqin_left">
                <el-input size="small" placeholder="apk/ios下载地址" style="width: 360px"
                          v-model="item.url"></el-input>
              </div>
              <div class="xiangqin_left">
                <el-input size="small"
                          placeholder="无用字段保持0即可"
                          style="width: 150px;text-align:center"
                          v-model.number="item.weight"></el-input>
              </div>
              <div class="xiangqin_left">
                备用字段：
                <el-input size="small"
                          placeholder="备用字段"
                          style="width: 150px;text-align:center"
                          v-model="item.desc"></el-input>
              </div>
              <div class="xiangqin_right">
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    size="small"
                    @click="deleteItem(i)"
                ></el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="域名操作:">
            <el-button type="primary" size="small" @click="handleChangeDomain(params.type,true)"
            >刷新同步
            </el-button >
            <el-button type="primary" size="small" @click="addDomain()"
            >新增配置
            </el-button
            >
          </el-form-item>
        </template>
        <template v-else-if="params.type == 'COMMUNITYLAYOUT'">
          <el-form-item label="下载地址:" prop="domain">
            <div class="xiangqin" v-for="(item, i) in params.domain" :key="i">
              <div
                  class="xiangqin_left"
              >
                <el-input
                    size="small"
                    v-model="item.title"
                    placeholder="apk版本号"
                    style="width: 150px;text-align:center"
                ></el-input>
              </div>
              <div class="xiangqin_left">
                <el-input size="small" placeholder="apk/ios下载地址" style="width: 320px"
                          v-model="item.url"></el-input>
              </div>
              <div class="xiangqin_left">
                <el-input size="small"
                          placeholder="0是(1大2小) / 1是(横版)"
                          style="width: 150px;text-align:center"
                          v-model.number="item.weight"></el-input>
                {{ item.weight == 0 ? "1大2小" : "横版" }}
              </div>
              <div class="xiangqin_left">
                备用字段：
                <el-input size="small"
                          placeholder="备用字段"
                          style="width: 150px;text-align:center"
                          v-model="item.desc"></el-input>
              </div>
              <div class="xiangqin_right">
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    size="small"
                    @click="deleteItem(i)"
                ></el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="域名操作:">
            <el-button type="primary" size="small" @click="addDomain()"
            >新增配置
            </el-button
            >
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="域名:" prop="domain">
            <div class="xiangqin" v-for="(item, i) in params.domain" :key="i">
              <div
                  class="xiangqin_left"

              >
                标题:
                <el-input
                    size="small"
                    v-model="item.title"
                    placeholder="请输入标题"
                    style="width: 150px;text-align:center"
                ></el-input>
              </div>
              <div class="xiangqin_left">
                url:
                <el-input
                    size="small"
                    style="width: 260px"
                    v-model="item.url"
                    placeholder="请输入链接"
                ></el-input>
              </div>
              <div class="xiangqin_left" v-if="params.type=='MARKIMG'">
                开关条件:
                <el-input size="small" style="width: 220px;text-align:center" placeholder="0 不开启 1都开启 2VIP或者金币大于0用户" v-model.number="item.weight"></el-input>
              </div>
              <div class="xiangqin_left" v-else>
                权重:
                <el-input size="small" style="width: 150px;text-align:center" v-model.number="item.weight"></el-input>
              </div>
              <div class="xiangqin_left">
                备用字段：
                <el-input size="small"
                          placeholder="备用字段"
                          style="width: 80px;text-align:center"
                          v-model="item.desc"></el-input>
              </div>
              <div class="xiangqin_right" v-if="params.type=='COINIMG'">
                上传封面：
                <base-upload
                    class="upload"
                    :key="params.domain[0].url"
                    :cover="params.domain[0].url"
                    :action="action"
                    :wSize="375"
                    :hSize="200"
                    :width="'45px'"
                    :height="'45px'"
                    @successCallback="handleUploadImg"
                ></base-upload>
              </div>
              <div class="xiangqin_right" v-else>
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    size="small"
                    @click="deleteItem(i)"
                ></el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="备注说明：" v-if="params.type=='MARKIMG'">
            <div>
                <div>提示：[0/1,0/1,0/1]   0关闭 1开启</div>
                <div>第1位置：0不显示免费角标    1显示</div>
                <div>第2位置：0 不显示VIP角标   1显示</div>
                <div>第3位置：0 不显示金币角标   1显示</div>
            </div>
            <el-button type="primary" size="small" @click="addDomain()">
              新增配置
            </el-button>
          </el-form-item>
          <el-form-item label="域名操作:" v-else>
            <el-button type="primary" size="small" @click="addDomain()">
              新增配置
            </el-button>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
            type="primary"
            @click="submitForm('form')"
            :loading="flag"
            size="small"
        >确 认
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import Axios from "axios";
import {ADMIN_APPID} from "@/config";
import local from "@/utils/localStroage";
import baseConfig from "@/utils/serverUrlConfig";


export default {
  data() {
    return {
      dialogVisible: false,
      isAdd: false,
      isClickAdd: false,
      isClickDelete: false,
      width: "960px",
      title: "",
      flag: false,
      id: "",
      type: "",
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      params: {
        domain: [{url:"",weight:0,title:"",desc:""}],
        type: "",
        sorted:1,
        devType:3,
        isActive: false,
      },
      typeList: [
        {label: "APP服务域名", value: "API"},
        {label: "视频，图片公用(CDN)", value: "COMMON"},
        {label: "视频专用域名(CDN)", value: "VID"},
        {label: "图片专用域名(CDN)", value: "IMAGE"},
        {label: "官方群号地址", value: "GROUP"},
        {label: "IOS导航域名", value: "GUIDE"},
        {label: "客服中心", value: "CUST"},
        {label: "免费观影配置", value: "PLAYCONFIG"},
        {label: "官网地址", value: "OFFICALWEBSITEADDRESS"},
        {label: "导航站线路地址", value: "NAVLINKADDR"},
        {label: "IOSAPI资源域名地址", value: "IOSAPI"},
        {label: "IOS视频资源地址(CDN)", value: "VID"},
        {label: "IOS图片资源地址(CDN)", value: "IMAGE"},
        {label: "VIP会员卡展示", value: "VIPCARD"},
        {label: "模块默认选中子元素", value: "MODULESELECTINDEX"},
        {label: "安卓下载地址和版本", value: "ANDROIDVERSION"},
        {label: "IOS下载地址和版本", value: "IOSVERSION"},
        {label: "社区数据布局", value: "COMMUNITYLAYOUT"},
        {label: "金刚区总开关", value: "NAVOPEN"},
        {label: "金币充值引导图", value: "COINIMG"},
        {label: "全局角标控制", value: "MARKIMG"},
      ],
      rules: {
        domain: [
          {required: true, message: "请添加域名", trigger: "blur"},
          {validator: this.validatorAttr, trigger: "blur"},
        ],
        type: [
          {required: true, message: "请选择域名类型", trigger: "change"},
        ],
      },
    };
  },
  computed: {
    userInfo: () => {
      return local.get("userInfo");
    },
  },
  methods: {

    handleUploadImg(res){
      this.params.domain[0].title = "充值图片"
      this.params.domain[0].url = res.data.coverImg
      this.params.domain[0].weight = 0
    },

    handleChangeDomain(e,flag) {
      if (e == "ANDROIDVERSION" || e == "IOSVERSION") {
        const terminal = e == "ANDROIDVERSION" ? "android" : "ios";
        Axios.post("https://api.biqku2sgok.top/api/stat/version/get", {
          "appId": ADMIN_APPID,
          "terminal": terminal
        }).then(res => {
          if(!flag)this.params.domain[0].title = "1.0.0";
          if(e == "ANDROIDVERSION" && res.data.data && res.data.data.link)this.params.domain[0].url = res.data.data.link[0] || "";
          if(e == "IOSVERSION" && res.data.data && res.data.data.iosH5Url)this.params.domain[0].url = res.data.data.iosH5Url || "";
          this.params.domain[0].weight = 0
        })
      }
    },

    // 校验domain的数据是否正确
    validatorAttr(rule, value, callback) {
      if (value.length === 0) {
        callback(new Error("请添加域名"));
      } else {
        for (let i = 0; i < value.length; i++) {
          if (!value[i].url) {
            callback(new Error("请填写所有的url项"));
          }
          if (value[i].weight === "") {
            callback(new Error("请填写所有的权重项"));
          }
        }
        callback();
      }
    },
    // 删除某项
    deleteItem(i) {
      this.params.domain.splice(i, 1);
    },
    // 新增域名
    addDomain() {
      let obj = {url: "", weight: "", title: "",desc:""};
      this.params.domain.push(obj);
    },
    // 提交修改
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.title === "新增资源") {
            this.addResource();
          } else {
            this.editResource();
          }
        } else {
          return false;
        }
      });
    },
    editResource() {
      let params = Object.assign({}, this.params, {id: this.id,"manager":this.userInfo.admin.name});
      API.editSource(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "修改资源成功",
                type: "success",
              });
              this.$emit("handlerResourceList");
            } else {
              this.$message.error("修改资源失败");
            }
            this.flag = false;
            this.handleClose();
          })
          .catch(() => {
            this.flag = false;
            this.handleClose();
          });
    },
    // 添加资源
    addResource() {
      let params = Object.assign({}, this.params,{"manager":this.userInfo.admin.name});
      API.addSource(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "新增资源成功",
                type: "success",
              });
              this.$emit("handlerResourceList");
            } else {
              this.$message.error("新增资源失败");
            }
            this.flag = false;
            this.handleClose();
          })
          .catch(() => {
            this.flag = false;
            this.handleClose();
          });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.isAdd = false;
      this.num = 0;
      this.params = {
        domain: [],
        type: "",
        isActive: false,
        sorted:1,
        devType:3,
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      if (type === "edit") {
        this.title = "编辑资源";
        this.params.domain = [...data.domain];
        this.params.type = data.type;
        this.params.isActive = data.isActive;
        this.params.devType = data.devType || 3
        this.params.sorted = data.sorted || 1
        this.id = data.id;
      } else {
        (this.title = "新增资源"), (this.isAdd = true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.add-pay-box {
  .el-input {
    width: 180px;
    margin-right: 15px;
  }

  .avatar-uploader {
    width: 150px;
    height: 150px;
  }

  .xiangqin {
    // width: 300px;
    // padding-left: 180px;
    display: flex;
    // justify-content: flex-start;
    align-items: center;

    .xiangqin_left {
      // margin-right: 15px;
    }

    .el-form-item {
      margin-left: 0px;
    }
  }

  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border: 1px dashed #e63765;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;

    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}

.type_wrapper {

}

.type_wrapper /deep/ .el-input {
  // border-color: #ff0000;
  // background-color: #f0f0f0;
  width: 180px;
}
</style>
